export const CHECKED = 'headCheck'
export const HEAD_FIXED = 'headFixed'
export const MAX = 10
export const MIN = 5



// WEBPACK FOOTER //
// ./src/commons/ZmTableData/const.js